import { CompanyEquipment, CompanyIndustry, CompanyMarket } from "@/graphql/codegen/graphql"

export const CompanyIndustryLabelMap = new Map<CompanyIndustry, string>([
  [CompanyIndustry.Silicone, "Silicone"],
  [CompanyIndustry.Rubber, "Rubber"],
  [CompanyIndustry.Plastics, "Plastics"],
  [CompanyIndustry.Coatings, "Coatings"],
  [CompanyIndustry.Adhesives, "Adhesives"],
  [CompanyIndustry.FoodAdditives, "Food Additives"],
  [CompanyIndustry.Cosmetics, "Cosmetics"],
])

export const CompanyMarketLabelMap = new Map<CompanyMarket, string>([
  [CompanyMarket.Automotive, "Automotive"],
  [CompanyMarket.Medical, "Medical"],
  [CompanyMarket.Agriculture, "Agriculture"],
  [CompanyMarket.Industrial, "Industrial"],
  [CompanyMarket.Construction, "Construction"],
  [CompanyMarket.Aerospace, "Aerospace"],
  [CompanyMarket.ConsumerGoods, "Consumer Goods"],
  [CompanyMarket.Packaging, "Packaging"],
  [CompanyMarket.Footwear, "Footwear"],
  [CompanyMarket.Tire, "Tire"],
  [CompanyMarket.Hose, "Hose"],
  [CompanyMarket.WireCable, "Wire Cable"],
  [CompanyMarket.Belts, "Belts"],
  [CompanyMarket.Seals, "Seals"],
  [CompanyMarket.CustomerCompounding, "Customer Compounding"],
  [CompanyMarket.Other, "Other"],
])

export const CompanyEquipmentLabelMap = new Map<CompanyEquipment, string>([
  [CompanyEquipment.HighShearMixer, "High Shear Mixer"],
  [CompanyEquipment.LowShearMixer, "Low Shear Mixer"],
  [CompanyEquipment.Extruder, "Extruder"],
  [CompanyEquipment.SaltBath, "Salt Bath"],
  [CompanyEquipment.Microwave, "Microwave"],
  [CompanyEquipment.Autoclave, "Autoclave"],
  [CompanyEquipment.Calender, "Calender"],
  [CompanyEquipment.RotoMold, "Roto Mold"],
  [CompanyEquipment.InjectionMold, "Injection Mold"],
  [CompanyEquipment.TransferMold, "Transfer Mold"],
  [CompanyEquipment.CompressionMold, "Compression Mold"],
])
